const APPLIED_DOMAIN = import.meta.env.VITE_APPLIED_DOMAIN || '';

/**
 * Resolves the partner slug from a URL's hostname.
 *
 * Lives here rather than in currentPartnerQuery so the reference storage layer can resolve a
 * slug synchronously without importing a query module (which would pull axios and the CRM
 * client into its module graph).
 */
export function extractPartnerName(url: string) {
  if (import.meta.env.VITE_DEV_PARTNER) {
    return import.meta.env.VITE_DEV_PARTNER as string;
  }

  if (!APPLIED_DOMAIN) return '';

  const hostname = new URL(url).hostname;

  if (hostname.endsWith(APPLIED_DOMAIN)) {
    const index = hostname.lastIndexOf(APPLIED_DOMAIN);

    const subdomain = hostname.substring(0, index - 1); // -1 to remove the trailing dot

    const parts = subdomain.split('.');
    return parts.length > 0 ? parts[parts.length - 1] : '';
  }

  return '';
}
